import React from 'react';

import { EventsProvider, SportsProvider } from '@atlas/core';

import TopEventsSlider from './TopEventsSlider';

const TopEvents = () => (
  <SportsProvider>
    <EventsProvider eventsType="topEvents">
      <TopEventsSlider />
    </EventsProvider>
  </SportsProvider>
);

export default TopEvents;
